import React from 'react';
import ReactTooltip from "react-tooltip";
import './shortcut-tooltip.less';
import makeShortCutKeyObservable from '../../utils/makeShortCutKeyObservable';

export default class ShortCutTooltip extends React.Component {
	componentDidMount() {
		var matchesShortCutKey = ({keyPressed, altKey}) => altKey && keyPressed == this.props.shortcutKey;
        var shortcut$ = makeShortCutKeyObservable(matchesShortCutKey);

		this.shortcutKeySubscription = shortcut$.subscribe(e => {
			this.props.onShortCutKeyPressed();
		});
	}
	componentWillUnmount() {
		this.shortcutKeySubscription.dispose();
	}
	render() {
		var { id, label, shortcutKey } = this.props;

		return(
            <ReactTooltip id={id} place='bottom' type='dark'>
                <span className="shortcut-tooltip-label">{label} (<span className="shortcut-tooltip-shortcut-key">alt+{shortcutKey}</span>)</span>
            </ReactTooltip>
		);
	}
}


// WEBPACK FOOTER //
// ./app/c3/shortcut-tooltip/ShortCutTooltip.js